const SEO_CONFIG = {
  siteName: "BuildNear",

  siteUrl: "https://buildnear.in",

  defaultTitle:
    "BuildNear | Find Trusted Construction Material Dealers Near You",

  defaultDescription:
    "Find verified construction material dealers, hardware stores, tile suppliers, cement dealers, steel suppliers and construction professionals near you.",

  defaultImage:
    "https://buildnear.in/images/logo/buildnear-logo-3d-512.png",

  twitterHandle: "@BuildNear",

  themeColor: "#0d6efd",
};

export default SEO_CONFIG;